import { gql, useQuery } from '@apollo/client';

const PROMPT_GET = gql`
  query PromptGet($id: ID!) {
    promptGet(id: $id) {
      id
      text
    }
  }
`;

export function usePromptTextById(promptId?: string) {
  const shouldSkip = !promptId;

  const { data } = useQuery(PROMPT_GET, {
    variables: { id: promptId as string },
    skip: shouldSkip
  });

  return (data?.promptGet?.text as string) ?? '';
}
